<div>
  @if (app.filterList.field !== null) {
    <div
      class="col-md-8 no-padding pb-3 fa-pull-right"
      >
      @if (getFieldType(app.filterList.field) == 'options') {
        <div>
          <div class="box">
            @if (app.filterList.field != null) {
              <button
                class="btn btn-sm selected selectedFilter"
          (click)="
            app.filterList.field = null;
            app.filterList.open = true;
            optionSearchTerm = ''
          "
                type="button"
                >
                {{ app.field.getLabel(app.filterList.field) }}
                <i class="fa fa-times app-subtle"></i>
              </button>
            }
            <div class="dropdown">
              <input
                class="form-control dropdown-filter dropdown-toggle"
                data-bs-toggle="dropdown"
                [(ngModel)]="optionSearchTerm"
                (click)="app.filterTable.isDropdownOpen = true"
                />
              @if (
                app.filter.isSelected(app.filterList.field, getActiveFilters())
                ) {
                <button
                  class="btn clear-dropdown"
                  >
                  <i
                    class="fa fa-times icon-size"
                    (click)="clearFilter(app.filterList.field)"
                  ></i>
                </button>
              }
              <div class="dropdown-menu dropdown-list">
                @for (option of getFilteredCurrentOptions(); track option) {
                  <div>
                    <!-- <label class="checkbox-label" (click)="$event.stopPropagation()"> -->
                    <div
                      class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                      (click)="selectOption(app.filterList.field, option)"
                      >
                      <span class="label">
                        {{
                        app.filterTree.getOptionText(app.filterList.field, option)
                        }}
                      </span>
                    </div>
                  <!-- </label> -->
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (getFieldType(app.filterList.field) == 'user-options') {
      <div>
        <div class="box">
          @if (app.filterList.field != null) {
            <button
              class="btn btn-sm selected selectedFilter"
          (click)="
            app.filterList.field = null;
            app.filterList.open = true;
            optionSearchTerm = ''
          "
              type="button"
              >
              {{ app.field.getLabel(app.filterList.field) }}
              <i class="fa fa-times app-subtle"></i>
            </button>
          }
          <div class="dropdown">
            <input
              class="form-control dropdown-filter dropdown-toggle"
              data-bs-toggle="dropdown"
              [(ngModel)]="optionSearchTerm"
              (click)="app.filterTable.isDropdownOpen = true"
              />
            <div class="dropdown-menu dropdown-list">
              @for (option of getFilteredCurrentOptions(); track option) {
                <div>
                  @if (option.name?.trim()) {
                    <div
                      class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                      (click)="selectOption(app.filterList.field, option.id)"
                      >
                      <span class="label">
                        {{ option.name }}
                      </span>
                    </div>
                  }
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (getFieldType(app.filterList.field) == 'dataList') {
      <div>
        <div class="box">
          @if (app.filterList.field != null) {
            <button
              class="btn btn-sm selected selectedFilter"
          (click)="
            app.filterList.field = null;
            app.filterList.open = true;
            optionSearchTerm = ''
          "
              type="button"
              >
              {{ app.field.getLabel(app.filterList.field) }}
              <i class="fa fa-times app-subtle"></i>
            </button>
          }
          <div class="dropdown">
            <input
              class="form-control dropdown-filter dropdown-toggle"
              data-bs-toggle="dropdown"
              [(ngModel)]="optionSearchTerm"
              (click)="app.filterTable.isDropdownOpen = true"
              />
            @if (
              app.filter.isSelected(app.filterList.field, getActiveFilters())
              ) {
              <button
                class="btn clear-dropdown"
                >
                <i
                  class="fa fa-times icon-size"
                  (click)="clearFilter(app.filterList.field)"
                ></i>
              </button>
            }
            <div class="dropdown-menu dropdown-list">
              @for (option of getFilteredCurrentOptions(); track option) {
                <div>
                  <div
                    class="filter-row"
                [class.selected]="
                  app.filter.isChecked(
                    app.filterList.field,
                    option,
                    getActiveFilters()
                  )
                "
                    (click)="selectOption(app.filterList.field, option)"
                    >
                    <span class="label">{{ option }}</span>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    }
    @if (getFieldType(app.filterList.field) == 'dateInterval') {
      <div>
        @if (app.datesFilter.getRangeFields(app.filterList.field); as range) {
          <div
            class="box"
            >
            @if (app.filterList.field != null) {
              <button
                class="btn btn-sm selected selectedFilter"
                (click)="app.filterList.field = null; app.filterList.open = true"
                type="button"
                >
                {{ app.field.getLabel(range.specific) }}
                <i class="fa fa-times app-subtle"></i>
              </button>
            }
            <div class="dates-filter-anchor">
              <input
                class="form-control inputStyle typeaheadFilters"
                readonly
                [ngModel]="getDateFilterLabel()"
                (mousedown)="openDatesFilter($event)"
                placeholder="Select date"
                />
              @if (app.datesFilter.showComponent) {
                <div>
                  <app-dates-filter [docType]="app.type"></app-dates-filter>
                </div>
              }
            </div>
          </div>
        }
      </div>
    }
    @if (getFieldType(app.filterList.field) == 'typeahead') {
      <div>
        <app-field
          [model]="app.model"
          [field]="app.filterList.field"
          [differentDisplay]="true"
          [showLabel]="false"
          [typeaheadPlaceholder]="'Search'"
          >
        </app-field>
      </div>
    }
  </div>
}
@if (getFilterFields()) {
  <div>
    @for (filter of app.state.filterByPage; track filter) {
      <div>
        @if (
          filter.filterLabelField &&
          !app.filterFields.isQuickFilterField(filter.filterLabelField) &&
          filter.filterLabelField !== app.fieldId.thread.to &&
          filter.filterLabelField !== app.fieldId.thread.validationDateTo
          ) {
          <button
            (click)="clearFilter(filter.filterLabelField); $event.stopPropagation()"
            class="button btn p-0 pb-3 m-0 pull-right"
            [ngbTooltip]="app.text.filter.remove"
            >
            <span class="badge badge-pill badge-om p-2">
              {{ getFilterChipText(filter) }}
              &nbsp;
              <i class="far fa-times-circle"></i>
            </span>
          </button>
        }
      </div>
    }
  </div>
}
</div>
